export const KLAVIYOEVENTS = {
    ActiveOnSite: "Active on Site",
    ProductViewed: "Product Viewed",
    ProductAddedToCart: "Product Added to Cart",
    NewSignUp : "New Sign Up"
}
